import { useState } from 'react'

import { ContainerForm } from '../ContainerForm'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { FieldSnack, schema } from './validationSchema'
import { ReactComponent as ImageIcon } from '../../../assets/image.svg'
import { SnackDataType } from '../../../interfaces/SnackData'

interface FormSnackTypeProps {
  submit: (data: SnackDataType) => void
}

export const FormSnack = ({ submit }: FormSnackTypeProps) => {
  const [prev, setPrev] = useState<File | null>(null)
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FieldSnack>({
    resolver: yupResolver(schema),
  })

  return (
    <form onSubmit={handleSubmit(submit)}>
      <ContainerForm textBtn='Cadastrar'>
        <label>
          <div className='image'>
            {prev ? (
              <img src={URL.createObjectURL(prev)} alt='' />
            ) : (
              <>
                <ImageIcon />
                <p>Procurar</p>
              </>
            )}
          </div>

          <input
            type='file'
            name=''
            id=''
            onChange={(e) => setPrev(e.target.files ? e.target.files[0] : null)}
            style={{ display: 'none' }}
          />
        </label>

        {errors.image && <p className='error'>{errors.image.message}</p>}
        <div className='grouped'>
          <div className={`field ${errors.name ? 'error' : ''}`}>
            <label htmlFor='name'>Name</label>
            <Controller
              name='name'
              control={control}
              render={({ field }) => <input type='text' id='name' {...field} />}
            />
            {errors.name && <p>{errors.name.message}</p>}
          </div>
          <div className={`field ${errors.price ? 'error' : ''}`}>
            <label htmlFor='price'>Preço</label>
            <Controller
              name='price'
              control={control}
              render={({ field }) => <input type='text' id='price' {...field} />}
            />
            {errors.price && <p>{errors.price.message}</p>}
          </div>
          <div className={`field ${errors.snack ? 'error' : ''}`}>
            <label htmlFor='name'>Tipo</label>
            <Controller
              name='snack'
              control={control}
              render={({ field }) => (
                <select id='snack' {...field}>
                  <option value=''>Selcione</option>
                  <option value='burgger'>Burger</option>
                </select>
              )}
            />
            {errors.name && <p>{errors.name.message}</p>}
          </div>
        </div>

        <div className={`field ${errors.description ? 'error' : ''}`}>
          <label htmlFor='description'>Descrição</label>
          <Controller
            name='description'
            control={control}
            render={({ field }) => <textarea id='description' {...field}></textarea>}
          />
          {errors.description && <p>{errors.description.message}</p>}
        </div>
      </ContainerForm>
    </form>
  )
}
